// extracted by mini-css-extract-plugin
export default {"form":"src-feature-ui-__dialog-form_form"};